import React from 'react'

import styles from './BadgeList.module.scss'

interface BadgeListProps<T> {
  title?: string
  itemList: T[]
  children(item: T, idx: number): JSX.Element
  onToggle: (value: T) => void
}

export function BadgeList <T>({ title, itemList, onToggle, children }: BadgeListProps<T>) {
  const onHandleClick = (value: T) => () => onToggle(value)

  return itemList.length ? (
    <div className={styles.container}>
      {title && <h2 className={styles.title}>{title}</h2>}
      <div className={styles.containerList}>
        {itemList.map((item, index) => (
          <div onClick={onHandleClick(item)} key={index} className={styles.item}>
            {children(item, index)}
          </div>
        ))}
      </div>
    </div>
  ) : null
}
